module.exports = __webpack_public_path__ + "static/media/logo.a0f9dd7b.svg";